import { renderToStaticMarkup } from 'react-dom/server'
import { type ResourceModel, type TemplateColumnConfig } from '@bryntum/schedulerpro'
import { selectUserConfiguration } from '@/features/domain/user'
import { store } from '@/store'
import { intl } from '@/intl'

import { OrdersUndeclaredCell } from '../../../components/cells/OrdersUndeclaredCell'
import { ordersUndeclaredSorter } from '../sorters/ordersUndeclaredSorter'

export function createOrdersUndeclaredColumn(
  width: string | number,
  hidden: boolean,
): Partial<TemplateColumnConfig> {
  return {
    text: intl.translate({ id: 'rm.scheduler.column.ordersExecutedUndeclared' }),
    type: 'template',
    field: 'ordersExecutedUndeclared',
    width,
    editor: false,
    hidden,
    region: 'cols',

    template: ({ record, field, value }) => {
      const state = store.getState()
      const { language } = selectUserConfiguration(state)

      return renderToStaticMarkup(
        <OrdersUndeclaredCell
          record={record as ResourceModel}
          field={field}
          value={value}
          language={language}
        />,
      )
    },

    sortable: ordersUndeclaredSorter,
    resizable: true,
    groupable: false,
  }
}
